import { useTranslation } from 'react-i18next';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: string;
  trend?: string;
  trendUp?: boolean;
}

export default function StatsCard({ title, value, icon, trend, trendUp }: StatsCardProps) {
  const { t } = useTranslation('dashboard');
  
  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mt-2">{value}</p>
          {trend && (
            <div className="flex items-center gap-1 mt-2">
              <i className={`${trendUp ? 'ri-arrow-up-line text-green-500' : 'ri-arrow-down-line text-red-500'} text-sm`}></i>
              <span className={`text-sm font-medium ${trendUp ? 'text-green-600' : 'text-red-600'}`}>
                {trend}
              </span>
              <span className="text-sm text-gray-500">{t('stats.today')}</span>
            </div>
          )}
        </div>
        <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
          <i className={`${icon} text-teal-600 text-2xl`}></i>
        </div>
      </div>
    </div>
  );
}
